<div class="card-body pt-4">
    <div class="card-title font-weight-bold">
        <ng-content select="[title]"></ng-content>
    </div>
    <div class="card-text" [ngClass]="{'pt-4': isContentUpperPadding}">
        <ng-content select="[content]"></ng-content>
    </div>
</div>
<div class="card-footer border-0">
    <ng-content select="[actionButton]"></ng-content>
</div>